import { useTranslation } from "react-i18next";
import BookingDatesMb from "./bookingDates/mb";
import RoomInfMb from "./roomInf/mobile";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { modalControl } from "util/commAction";
import {
  BookInfProvider,
  useBookInfContext,
} from "components/context/bookInfContext";
import PromCdModalInner from "./roomInf/promcdModal/promCdModal";
import Button from "components/button/default";

export default function HomeMb() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const promCd = queryParams.get("promCd");
  const { lodNo } = useParams();
  const { dateRange, dates, onBookInf } = useBookInfContext();

  return (
    <>
      <div className="home-mb">
        <div>
          <div className="mt-[2rem] mb-[1.5rem]">
            <h2>Reservation</h2>
          </div>
          <div className="flex flex-col gap-y-4">
            {/* 숙박일자 선택 */}
            <BookingDatesMb
              text={
                dates.length !== 2
                  ? t("bck_ttl_hm_ldg_dt_slt")
                  : t("bck_ttl_hm_ldg_dt")
              }
            />

            <RoomInfMb />

            {/* ProMotionCode */}
            <div className="prom-cd">
              <h5 className="text-blue-300 font-font-B mb-[15px]">
                {!!promCd ? t("bck_ttl_prmCd") : t("bck_dscrp_hm_prmCd")}
              </h5>
              {!!promCd && <h5 className="font-font-B">{promCd}</h5>}
              {!promCd && (
                <Button
                  text={t("btn_hm_app_prmCd")}
                  styels="w-48"
                  onClick={() => {
                    modalControl({
                      isOpen: true,
                      btnTxt: t("btn_hm_md_app_code"),
                      chckBtn: false,
                      inner: (
                        <BookInfProvider>
                          <PromCdModalInner />
                        </BookInfProvider>
                      ),
                    });
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* 검색버튼 */}
      <div className="btn-bottom">
        <button
          className="btn-search"
          onClick={() => {
            navigate("book", {
              state: {
                dateRange,
                dates,
                promCd,
                lodNo,
              },
            });
            onBookInf({
              dateRange,
              dates,
              promCd,
              lodNo,
            });
          }}
        >
          {t("btn_hm_romInq")}
        </button>
      </div>
    </>
  );
}
